//////////////////////////////////////////////////////////////////////////////////////////////
// DO NOT MODIFY THIS FILE                                                                  //
// This file is automatically generated by ZenStack CLI and should not be manually updated. //
//////////////////////////////////////////////////////////////////////////////////////////////

/* eslint-disable */

import { type SchemaDef, type AttributeApplication, type FieldDefault, ExpressionUtils } from "@zenstackhq/schema";
export class SchemaType implements SchemaDef {
    provider = {
        type: "postgresql"
    } as const;
    models = {
        User: {
            name: "User",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                email: {
                    name: "email",
                    type: "String",
                    unique: true
                },
                password: {
                    name: "password",
                    type: "String",
                    omit: true
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "Role",
                    default: "USER" as FieldDefault
                },
                approved: {
                    name: "approved",
                    type: "Boolean",
                    default: false as FieldDefault
                },
                notificationsEnabled: {
                    name: "notificationsEnabled",
                    type: "Boolean",
                    default: true as FieldDefault
                },
                dndStart: {
                    name: "dndStart",
                    type: "String",
                    optional: true
                },
                dndEnd: {
                    name: "dndEnd",
                    type: "String",
                    optional: true
                },
                dndTimezone: {
                    name: "dndTimezone",
                    type: "String",
                    default: "Europe/Sofia" as FieldDefault
                },
                memberships: {
                    name: "memberships",
                    type: "AccountMember",
                    array: true,
                    relation: { opposite: "user" }
                },
                invitesSent: {
                    name: "invitesSent",
                    type: "Invite",
                    array: true,
                    relation: { opposite: "invitedBy", name: "invitedBy" }
                },
                authoredMessages: {
                    name: "authoredMessages",
                    type: "Message",
                    array: true,
                    relation: { opposite: "createdBy", name: "messageAuthor" }
                },
                messageReads: {
                    name: "messageReads",
                    type: "MessageRead",
                    array: true,
                    relation: { opposite: "user" }
                },
                callReads: {
                    name: "callReads",
                    type: "CallRead",
                    array: true,
                    relation: { opposite: "user" }
                },
                auditEntries: {
                    name: "auditEntries",
                    type: "AuditLog",
                    array: true,
                    relation: { opposite: "actor", name: "auditActor" }
                },
                pushSubscriptions: {
                    name: "pushSubscriptions",
                    type: "PushSubscription",
                    array: true,
                    relation: { opposite: "user" }
                },
                sessionsValidFrom: {
                    name: "sessionsValidFrom",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                email: { type: "String" }
            }
        },
        Account: {
            name: "Account",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                label: {
                    name: "label",
                    type: "String",
                    optional: true
                },
                retentionDays: {
                    name: "retentionDays",
                    type: "Int",
                    default: 30 as FieldDefault
                },
                members: {
                    name: "members",
                    type: "AccountMember",
                    array: true,
                    relation: { opposite: "account" }
                },
                assistantConfig: {
                    name: "assistantConfig",
                    type: "AssistantConfig",
                    optional: true,
                    relation: { opposite: "account" }
                },
                voiceAgent: {
                    name: "voiceAgent",
                    type: "VoiceAgent",
                    optional: true,
                    relation: { opposite: "account" }
                },
                onboardingProgress: {
                    name: "onboardingProgress",
                    type: "OnboardingProgress",
                    optional: true,
                    relation: { opposite: "account" }
                },
                phoneNumbers: {
                    name: "phoneNumbers",
                    type: "PhoneNumber",
                    array: true,
                    relation: { opposite: "account" }
                },
                faqEntries: {
                    name: "faqEntries",
                    type: "FaqEntry",
                    array: true,
                    relation: { opposite: "account" }
                },
                contacts: {
                    name: "contacts",
                    type: "Contact",
                    array: true,
                    relation: { opposite: "account" }
                },
                blockedCallers: {
                    name: "blockedCallers",
                    type: "BlockedCaller",
                    array: true,
                    relation: { opposite: "account" }
                },
                tags: {
                    name: "tags",
                    type: "Tag",
                    array: true,
                    relation: { opposite: "account" }
                },
                calls: {
                    name: "calls",
                    type: "Call",
                    array: true,
                    relation: { opposite: "account" }
                },
                messages: {
                    name: "messages",
                    type: "Message",
                    array: true,
                    relation: { opposite: "account" }
                },
                auditLog: {
                    name: "auditLog",
                    type: "AuditLog",
                    array: true,
                    relation: { opposite: "account" }
                },
                invites: {
                    name: "invites",
                    type: "Invite",
                    array: true,
                    relation: { opposite: "account" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                },
                hasActiveNumber: {
                    name: "hasActiveNumber",
                    type: "Boolean",
                    computed: true
                },
                agentConfigured: {
                    name: "agentConfigured",
                    type: "Boolean",
                    computed: true
                },
                onboardingComplete: {
                    name: "onboardingComplete",
                    type: "Boolean",
                    computed: true
                },
                isActiveCustomer: {
                    name: "isActiveCustomer",
                    type: "Boolean",
                    computed: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            },
            computedFields: {
                hasActiveNumber(_context: {
                    modelAlias: string;
                }): boolean {
                    throw new Error("This is a stub for computed field");
                },
                agentConfigured(_context: {
                    modelAlias: string;
                }): boolean {
                    throw new Error("This is a stub for computed field");
                },
                onboardingComplete(_context: {
                    modelAlias: string;
                }): boolean {
                    throw new Error("This is a stub for computed field");
                },
                isActiveCustomer(_context: {
                    modelAlias: string;
                }): boolean {
                    throw new Error("This is a stub for computed field");
                }
            }
        },
        AccountMember: {
            name: "AccountMember",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    relation: { opposite: "members", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    relation: { opposite: "memberships", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                role: {
                    name: "role",
                    type: "AccountRole",
                    default: "VIEWER" as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId_userId: { accountId: { type: "String" }, userId: { type: "String" } }
            }
        },
        PhoneNumber: {
            name: "PhoneNumber",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    optional: true,
                    relation: { opposite: "phoneNumbers", fields: ["accountId"], references: ["id"], onDelete: "SetNull" }
                },
                e164: {
                    name: "e164",
                    type: "String",
                    unique: true
                },
                provider: {
                    name: "provider",
                    type: "String",
                    default: "zadarma" as FieldDefault
                },
                providerNumberId: {
                    name: "providerNumberId",
                    type: "String",
                    optional: true
                },
                status: {
                    name: "status",
                    type: "ProvisioningStatus",
                    default: "PROVISIONING" as FieldDefault
                },
                purchasedAt: {
                    name: "purchasedAt",
                    type: "DateTime",
                    optional: true
                },
                releasedAt: {
                    name: "releasedAt",
                    type: "DateTime",
                    optional: true
                },
                calls: {
                    name: "calls",
                    type: "Call",
                    array: true,
                    relation: { opposite: "phoneNumber" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                e164: { type: "String" }
            }
        },
        CarrierForwardingCode: {
            name: "CarrierForwardingCode",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                country: {
                    name: "country",
                    type: "String"
                },
                carrier: {
                    name: "carrier",
                    type: "String"
                },
                label: {
                    name: "label",
                    type: "String"
                },
                enableCode: {
                    name: "enableCode",
                    type: "String"
                },
                disableCode: {
                    name: "disableCode",
                    type: "String"
                },
                statusCode: {
                    name: "statusCode",
                    type: "String",
                    optional: true
                },
                notes: {
                    name: "notes",
                    type: "Json",
                    optional: true
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    default: true as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                country_carrier: { country: { type: "String" }, carrier: { type: "String" } }
            }
        },
        Voice: {
            name: "Voice",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                label: {
                    name: "label",
                    type: "String"
                },
                voiceId: {
                    name: "voiceId",
                    type: "String",
                    unique: true
                },
                language: {
                    name: "language",
                    type: "String",
                    optional: true
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    default: true as FieldDefault
                },
                configs: {
                    name: "configs",
                    type: "AssistantConfig",
                    array: true,
                    relation: { opposite: "voice" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                voiceId: { type: "String" }
            }
        },
        AssistantConfig: {
            name: "AssistantConfig",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    unique: true,
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    relation: { opposite: "assistantConfig", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                greetingName: {
                    name: "greetingName",
                    type: "String",
                    optional: true
                },
                greetingScript: {
                    name: "greetingScript",
                    type: "String",
                    optional: true
                },
                voiceId: {
                    name: "voiceId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "voice"
                    ] as readonly string[]
                },
                voice: {
                    name: "voice",
                    type: "Voice",
                    optional: true,
                    relation: { opposite: "configs", fields: ["voiceId"], references: ["id"], onDelete: "SetNull" }
                },
                customInstructions: {
                    name: "customInstructions",
                    type: "String",
                    optional: true
                },
                emergencyTopics: {
                    name: "emergencyTopics",
                    type: "String",
                    array: true,
                    default: [] as FieldDefault
                },
                language: {
                    name: "language",
                    type: "String",
                    default: "bg" as FieldDefault
                },
                autoSwitchEnglish: {
                    name: "autoSwitchEnglish",
                    type: "Boolean",
                    default: true as FieldDefault
                },
                ownNumber: {
                    name: "ownNumber",
                    type: "String",
                    optional: true
                },
                carrier: {
                    name: "carrier",
                    type: "String",
                    optional: true
                },
                forwardingConfirmedAt: {
                    name: "forwardingConfirmedAt",
                    type: "DateTime",
                    optional: true
                },
                minUrgencyToNotify: {
                    name: "minUrgencyToNotify",
                    type: "UrgencyLevel",
                    default: "NORMAL" as FieldDefault
                },
                smsFallbackFrom: {
                    name: "smsFallbackFrom",
                    type: "UrgencyLevel",
                    optional: true
                },
                shortCircuitSpam: {
                    name: "shortCircuitSpam",
                    type: "Boolean",
                    default: false as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId: { type: "String" }
            }
        },
        VoiceAgent: {
            name: "VoiceAgent",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    unique: true,
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    relation: { opposite: "voiceAgent", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                externalAgentId: {
                    name: "externalAgentId",
                    type: "String",
                    unique: true,
                    optional: true
                },
                config: {
                    name: "config",
                    type: "Json",
                    optional: true
                },
                faqDocumentId: {
                    name: "faqDocumentId",
                    type: "String",
                    optional: true
                },
                knowledgeDocs: {
                    name: "knowledgeDocs",
                    type: "AgentKnowledgeDoc",
                    array: true,
                    relation: { opposite: "agent" }
                },
                syncedAt: {
                    name: "syncedAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId: { type: "String" },
                externalAgentId: { type: "String" }
            }
        },
        CreditPackage: {
            name: "CreditPackage",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                label: {
                    name: "label",
                    type: "String",
                    optional: true
                },
                price: {
                    name: "price",
                    type: "Int"
                },
                currency: {
                    name: "currency",
                    type: "String",
                    default: "EUR" as FieldDefault
                },
                credits: {
                    name: "credits",
                    type: "Int"
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    default: true as FieldDefault
                },
                sortOrder: {
                    name: "sortOrder",
                    type: "Int",
                    default: 0 as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        AgentKnowledgeDoc: {
            name: "AgentKnowledgeDoc",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                agentId: {
                    name: "agentId",
                    type: "String",
                    foreignKeyFor: [
                        "agent"
                    ] as readonly string[]
                },
                agent: {
                    name: "agent",
                    type: "VoiceAgent",
                    relation: { opposite: "knowledgeDocs", fields: ["agentId"], references: ["id"], onDelete: "Cascade" }
                },
                title: {
                    name: "title",
                    type: "String"
                },
                text: {
                    name: "text",
                    type: "String"
                },
                documentId: {
                    name: "documentId",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        FaqEntry: {
            name: "FaqEntry",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    relation: { opposite: "faqEntries", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                question: {
                    name: "question",
                    type: "String"
                },
                answer: {
                    name: "answer",
                    type: "String"
                },
                position: {
                    name: "position",
                    type: "Int",
                    default: 0 as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        OnboardingProgress: {
            name: "OnboardingProgress",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    unique: true,
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    relation: { opposite: "onboardingProgress", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                currentStep: {
                    name: "currentStep",
                    type: "OnboardingStep",
                    optional: true
                },
                skippedSteps: {
                    name: "skippedSteps",
                    type: "OnboardingStep",
                    array: true,
                    default: [] as FieldDefault
                },
                completedAt: {
                    name: "completedAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId: { type: "String" }
            }
        },
        Call: {
            name: "Call",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                conversationId: {
                    name: "conversationId",
                    type: "String",
                    unique: true,
                    optional: true
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    relation: { opposite: "calls", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                phoneNumberId: {
                    name: "phoneNumberId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "phoneNumber"
                    ] as readonly string[]
                },
                phoneNumber: {
                    name: "phoneNumber",
                    type: "PhoneNumber",
                    optional: true,
                    relation: { opposite: "calls", fields: ["phoneNumberId"], references: ["id"], onDelete: "SetNull" }
                },
                callerName: {
                    name: "callerName",
                    type: "String",
                    optional: true
                },
                callerNumber: {
                    name: "callerNumber",
                    type: "String",
                    optional: true
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "contact"
                    ] as readonly string[]
                },
                contact: {
                    name: "contact",
                    type: "Contact",
                    optional: true,
                    relation: { opposite: "calls", fields: ["contactId"], references: ["id"], onDelete: "SetNull" }
                },
                status: {
                    name: "status",
                    type: "CallStatus",
                    default: "COMPLETED" as FieldDefault
                },
                urgencyLevel: {
                    name: "urgencyLevel",
                    type: "UrgencyLevel",
                    optional: true
                },
                startedAt: {
                    name: "startedAt",
                    type: "DateTime",
                    optional: true
                },
                endedAt: {
                    name: "endedAt",
                    type: "DateTime",
                    optional: true
                },
                durationSec: {
                    name: "durationSec",
                    type: "Int",
                    optional: true
                },
                endedReason: {
                    name: "endedReason",
                    type: "String",
                    optional: true
                },
                providerCostCents: {
                    name: "providerCostCents",
                    type: "Int",
                    optional: true
                },
                telephonyCostCents: {
                    name: "telephonyCostCents",
                    type: "Int",
                    optional: true
                },
                messages: {
                    name: "messages",
                    type: "Json",
                    optional: true
                },
                recording: {
                    name: "recording",
                    type: "CallRecording",
                    optional: true,
                    relation: { opposite: "call" }
                },
                transcript: {
                    name: "transcript",
                    type: "Transcript",
                    optional: true,
                    relation: { opposite: "call" }
                },
                summary: {
                    name: "summary",
                    type: "CallSummary",
                    optional: true,
                    relation: { opposite: "call" }
                },
                tags: {
                    name: "tags",
                    type: "CallTag",
                    array: true,
                    relation: { opposite: "call" }
                },
                reads: {
                    name: "reads",
                    type: "CallRead",
                    array: true,
                    relation: { opposite: "call" }
                },
                notification: {
                    name: "notification",
                    type: "Message",
                    optional: true,
                    relation: { opposite: "call" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                conversationId: { type: "String" }
            }
        },
        CallRecording: {
            name: "CallRecording",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                callId: {
                    name: "callId",
                    type: "String",
                    unique: true,
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    relation: { opposite: "recording", fields: ["callId"], references: ["id"], onDelete: "Cascade" }
                },
                storageKey: {
                    name: "storageKey",
                    type: "String"
                },
                mimeType: {
                    name: "mimeType",
                    type: "String",
                    optional: true,
                    default: "audio/mpeg" as FieldDefault
                },
                sizeBytes: {
                    name: "sizeBytes",
                    type: "Int",
                    optional: true
                },
                expiresAt: {
                    name: "expiresAt",
                    type: "DateTime"
                },
                deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId: { type: "String" }
            }
        },
        Transcript: {
            name: "Transcript",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                callId: {
                    name: "callId",
                    type: "String",
                    unique: true,
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    relation: { opposite: "transcript", fields: ["callId"], references: ["id"], onDelete: "Cascade" }
                },
                content: {
                    name: "content",
                    type: "String"
                },
                language: {
                    name: "language",
                    type: "String",
                    optional: true
                },
                expiresAt: {
                    name: "expiresAt",
                    type: "DateTime"
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId: { type: "String" }
            }
        },
        CallSummary: {
            name: "CallSummary",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                callId: {
                    name: "callId",
                    type: "String",
                    unique: true,
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    relation: { opposite: "summary", fields: ["callId"], references: ["id"], onDelete: "Cascade" }
                },
                summaryText: {
                    name: "summaryText",
                    type: "String"
                },
                model: {
                    name: "model",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId: { type: "String" }
            }
        },
        CallRead: {
            name: "CallRead",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                callId: {
                    name: "callId",
                    type: "String",
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    relation: { opposite: "reads", fields: ["callId"], references: ["id"], onDelete: "Cascade" }
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    relation: { opposite: "callReads", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                readAt: {
                    name: "readAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId_userId: { callId: { type: "String" }, userId: { type: "String" } }
            }
        },
        Tag: {
            name: "Tag",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    optional: true,
                    relation: { opposite: "tags", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                slug: {
                    name: "slug",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "Json"
                },
                isSystemDefault: {
                    name: "isSystemDefault",
                    type: "Boolean",
                    default: false as FieldDefault
                },
                calls: {
                    name: "calls",
                    type: "CallTag",
                    array: true,
                    relation: { opposite: "tag" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId_slug: { accountId: { type: "String" }, slug: { type: "String" } }
            }
        },
        CallTag: {
            name: "CallTag",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                callId: {
                    name: "callId",
                    type: "String",
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    relation: { opposite: "tags", fields: ["callId"], references: ["id"], onDelete: "Cascade" }
                },
                tagId: {
                    name: "tagId",
                    type: "String",
                    foreignKeyFor: [
                        "tag"
                    ] as readonly string[]
                },
                tag: {
                    name: "tag",
                    type: "Tag",
                    relation: { opposite: "calls", fields: ["tagId"], references: ["id"], onDelete: "Cascade" }
                },
                source: {
                    name: "source",
                    type: "TagSource",
                    default: "AUTO" as FieldDefault
                },
                confidence: {
                    name: "confidence",
                    type: "Float",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId_tagId: { callId: { type: "String" }, tagId: { type: "String" } }
            }
        },
        Contact: {
            name: "Contact",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    relation: { opposite: "contacts", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                e164: {
                    name: "e164",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                relationshipTag: {
                    name: "relationshipTag",
                    type: "String",
                    optional: true
                },
                notes: {
                    name: "notes",
                    type: "String",
                    optional: true
                },
                callMessage: {
                    name: "callMessage",
                    type: "String",
                    optional: true
                },
                callMessageExpiresAt: {
                    name: "callMessageExpiresAt",
                    type: "DateTime",
                    optional: true
                },
                calls: {
                    name: "calls",
                    type: "Call",
                    array: true,
                    relation: { opposite: "contact" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId_e164: { accountId: { type: "String" }, e164: { type: "String" } }
            }
        },
        BlockedCaller: {
            name: "BlockedCaller",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    relation: { opposite: "blockedCallers", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                e164: {
                    name: "e164",
                    type: "String"
                },
                source: {
                    name: "source",
                    type: "TagSource",
                    default: "AUTO" as FieldDefault
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId_e164: { accountId: { type: "String" }, e164: { type: "String" } }
            }
        },
        Message: {
            name: "Message",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                audience: {
                    name: "audience",
                    type: "MessageAudience",
                    default: "ACCOUNT" as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    optional: true,
                    relation: { opposite: "messages", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                severity: {
                    name: "severity",
                    type: "MessageSeverity",
                    default: "INFO" as FieldDefault
                },
                title: {
                    name: "title",
                    type: "String"
                },
                body: {
                    name: "body",
                    type: "String"
                },
                callId: {
                    name: "callId",
                    type: "String",
                    unique: true,
                    optional: true,
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    optional: true,
                    relation: { opposite: "notification", fields: ["callId"], references: ["id"], onDelete: "SetNull" }
                },
                createdById: {
                    name: "createdById",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "createdBy"
                    ] as readonly string[]
                },
                createdBy: {
                    name: "createdBy",
                    type: "User",
                    optional: true,
                    relation: { opposite: "authoredMessages", name: "messageAuthor", fields: ["createdById"], references: ["id"], onDelete: "SetNull" }
                },
                reads: {
                    name: "reads",
                    type: "MessageRead",
                    array: true,
                    relation: { opposite: "message" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId: { type: "String" }
            }
        },
        MessageRead: {
            name: "MessageRead",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                messageId: {
                    name: "messageId",
                    type: "String",
                    foreignKeyFor: [
                        "message"
                    ] as readonly string[]
                },
                message: {
                    name: "message",
                    type: "Message",
                    relation: { opposite: "reads", fields: ["messageId"], references: ["id"], onDelete: "Cascade" }
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    relation: { opposite: "messageReads", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                readAt: {
                    name: "readAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                messageId_userId: { messageId: { type: "String" }, userId: { type: "String" } }
            }
        },
        PushSubscription: {
            name: "PushSubscription",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    relation: { opposite: "pushSubscriptions", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                endpoint: {
                    name: "endpoint",
                    type: "String",
                    unique: true
                },
                p256dh: {
                    name: "p256dh",
                    type: "String",
                    omit: true
                },
                auth: {
                    name: "auth",
                    type: "String",
                    omit: true
                },
                userAgent: {
                    name: "userAgent",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                endpoint: { type: "String" }
            }
        },
        AuditLog: {
            name: "AuditLog",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    relation: { opposite: "auditLog", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                actorUserId: {
                    name: "actorUserId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "actor"
                    ] as readonly string[]
                },
                actor: {
                    name: "actor",
                    type: "User",
                    optional: true,
                    relation: { opposite: "auditEntries", name: "auditActor", fields: ["actorUserId"], references: ["id"], onDelete: "SetNull" }
                },
                action: {
                    name: "action",
                    type: "String"
                },
                targetType: {
                    name: "targetType",
                    type: "String",
                    optional: true
                },
                targetId: {
                    name: "targetId",
                    type: "String",
                    optional: true
                },
                metadata: {
                    name: "metadata",
                    type: "Json",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Invite: {
            name: "Invite",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                email: {
                    name: "email",
                    type: "String"
                },
                token: {
                    name: "token",
                    type: "String",
                    unique: true,
                    omit: true
                },
                role: {
                    name: "role",
                    type: "Role",
                    default: "USER" as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    optional: true,
                    relation: { opposite: "invites", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                accountRole: {
                    name: "accountRole",
                    type: "AccountRole",
                    optional: true
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                invitedById: {
                    name: "invitedById",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "invitedBy"
                    ] as readonly string[]
                },
                invitedBy: {
                    name: "invitedBy",
                    type: "User",
                    optional: true,
                    relation: { opposite: "invitesSent", name: "invitedBy", fields: ["invitedById"], references: ["id"], onDelete: "SetNull" }
                },
                visitedAt: {
                    name: "visitedAt",
                    type: "DateTime",
                    optional: true
                },
                usedAt: {
                    name: "usedAt",
                    type: "DateTime",
                    optional: true
                },
                expiresAt: {
                    name: "expiresAt",
                    type: "DateTime"
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                token: { type: "String" }
            }
        },
        EmailDelivery: {
            name: "EmailDelivery",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                resendId: {
                    name: "resendId",
                    type: "String",
                    unique: true
                },
                template: {
                    name: "template",
                    type: "String"
                },
                to: {
                    name: "to",
                    type: "String"
                },
                status: {
                    name: "status",
                    type: "String",
                    default: "sent" as FieldDefault
                },
                idempotencyKey: {
                    name: "idempotencyKey",
                    type: "String",
                    optional: true
                },
                lastEventAt: {
                    name: "lastEventAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                resendId: { type: "String" }
            }
        }
    } as const;
    typeDefs = {
        Auth: {
            name: "Auth",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "Role"
                },
                approved: {
                    name: "approved",
                    type: "Boolean"
                }
            },
            attributes: [
                { name: "@@auth" }
            ] as readonly AttributeApplication[]
        },
        SignUpInput: {
            name: "SignUpInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        LoginInput: {
            name: "LoginInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                }
            }
        },
        ChangePasswordInput: {
            name: "ChangePasswordInput",
            fields: {
                currentPassword: {
                    name: "currentPassword",
                    type: "String"
                },
                newPassword: {
                    name: "newPassword",
                    type: "String"
                }
            }
        },
        AdminSetPasswordInput: {
            name: "AdminSetPasswordInput",
            fields: {
                userId: {
                    name: "userId",
                    type: "String"
                },
                newPassword: {
                    name: "newPassword",
                    type: "String"
                }
            }
        },
        AdminInviteUserInput: {
            name: "AdminInviteUserInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "Role",
                    optional: true
                }
            }
        },
        InviteDelegateInput: {
            name: "InviteDelegateInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                email: {
                    name: "email",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "AccountRole",
                    optional: true
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        SetMemberRoleInput: {
            name: "SetMemberRoleInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                userId: {
                    name: "userId",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "AccountRole"
                }
            }
        },
        RemoveMemberInput: {
            name: "RemoveMemberInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                userId: {
                    name: "userId",
                    type: "String"
                }
            }
        },
        AdminCreateUserInput: {
            name: "AdminCreateUserInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "Role",
                    optional: true
                },
                approved: {
                    name: "approved",
                    type: "Boolean",
                    optional: true
                }
            }
        },
        UserIdInput: {
            name: "UserIdInput",
            fields: {
                userId: {
                    name: "userId",
                    type: "String"
                }
            }
        },
        AcceptInviteInput: {
            name: "AcceptInviteInput",
            fields: {
                token: {
                    name: "token",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String",
                    optional: true
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        CheckInviteInput: {
            name: "CheckInviteInput",
            fields: {
                token: {
                    name: "token",
                    type: "String"
                }
            }
        },
        CheckInviteResult: {
            name: "CheckInviteResult",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "Role"
                },
                accountLabel: {
                    name: "accountLabel",
                    type: "String",
                    optional: true
                },
                userExists: {
                    name: "userExists",
                    type: "Boolean"
                }
            }
        },
        InngestRunRow: {
            name: "InngestRunRow",
            fields: {
                runId: {
                    name: "runId",
                    type: "String"
                },
                functionName: {
                    name: "functionName",
                    type: "String",
                    optional: true
                },
                status: {
                    name: "status",
                    type: "String"
                },
                startedAt: {
                    name: "startedAt",
                    type: "String",
                    optional: true
                },
                endedAt: {
                    name: "endedAt",
                    type: "String",
                    optional: true
                },
                output: {
                    name: "output",
                    type: "String",
                    optional: true
                }
            }
        },
        InngestEventRow: {
            name: "InngestEventRow",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                receivedAt: {
                    name: "receivedAt",
                    type: "String",
                    optional: true
                },
                dataJson: {
                    name: "dataJson",
                    type: "String"
                },
                runs: {
                    name: "runs",
                    type: "InngestRunRow",
                    array: true
                }
            }
        },
        InngestActivityResult: {
            name: "InngestActivityResult",
            fields: {
                events: {
                    name: "events",
                    type: "InngestEventRow",
                    array: true
                },
                ok: {
                    name: "ok",
                    type: "Boolean"
                },
                error: {
                    name: "error",
                    type: "String",
                    optional: true
                }
            }
        },
        AssistantChatTurn: {
            name: "AssistantChatTurn",
            fields: {
                role: {
                    name: "role",
                    type: "String"
                },
                content: {
                    name: "content",
                    type: "String"
                }
            }
        },
        AssistantAskInput: {
            name: "AssistantAskInput",
            fields: {
                question: {
                    name: "question",
                    type: "String"
                },
                history: {
                    name: "history",
                    type: "AssistantChatTurn",
                    array: true
                },
                language: {
                    name: "language",
                    type: "String"
                },
                path: {
                    name: "path",
                    type: "String",
                    optional: true
                }
            }
        },
        AccountSummary: {
            name: "AccountSummary",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                label: {
                    name: "label",
                    type: "String",
                    optional: true
                },
                e164: {
                    name: "e164",
                    type: "String",
                    optional: true
                },
                myRole: {
                    name: "myRole",
                    type: "AccountRole"
                },
                unread: {
                    name: "unread",
                    type: "Int"
                },
                needsOnboarding: {
                    name: "needsOnboarding",
                    type: "Boolean"
                },
                setupUnfinished: {
                    name: "setupUnfinished",
                    type: "Boolean"
                }
            }
        },
        AccountSummaryList: {
            name: "AccountSummaryList",
            fields: {
                accounts: {
                    name: "accounts",
                    type: "AccountSummary",
                    array: true
                }
            }
        },
        AccountIdInput: {
            name: "AccountIdInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                }
            }
        },
        AssignPhoneNumberInput: {
            name: "AssignPhoneNumberInput",
            fields: {
                phoneNumberId: {
                    name: "phoneNumberId",
                    type: "String"
                },
                userId: {
                    name: "userId",
                    type: "String"
                }
            }
        },
        PhoneNumberIdInput: {
            name: "PhoneNumberIdInput",
            fields: {
                phoneNumberId: {
                    name: "phoneNumberId",
                    type: "String"
                }
            }
        },
        SkipStepInput: {
            name: "SkipStepInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                step: {
                    name: "step",
                    type: "OnboardingStep"
                }
            }
        },
        AgentFetchInput: {
            name: "AgentFetchInput",
            fields: {
                externalAgentId: {
                    name: "externalAgentId",
                    type: "String"
                }
            }
        },
        AgentDeployFaqInput: {
            name: "AgentDeployFaqInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                }
            }
        },
        AgentSyncResult: {
            name: "AgentSyncResult",
            fields: {
                syncedAt: {
                    name: "syncedAt",
                    type: "DateTime"
                },
                documentId: {
                    name: "documentId",
                    type: "String",
                    optional: true
                }
            }
        },
        AgentSyncInput: {
            name: "AgentSyncInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                }
            }
        },
        WorkspaceUsageInput: {
            name: "WorkspaceUsageInput",
            fields: {
                monthsBack: {
                    name: "monthsBack",
                    type: "Int",
                    optional: true
                }
            }
        },
        AccountUsageInput: {
            name: "AccountUsageInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                monthsBack: {
                    name: "monthsBack",
                    type: "Int",
                    optional: true
                }
            }
        },
        PushSubscribeInput: {
            name: "PushSubscribeInput",
            fields: {
                endpoint: {
                    name: "endpoint",
                    type: "String"
                },
                p256dh: {
                    name: "p256dh",
                    type: "String"
                },
                auth: {
                    name: "auth",
                    type: "String"
                },
                userAgent: {
                    name: "userAgent",
                    type: "String",
                    optional: true
                }
            }
        },
        PushUnsubscribeInput: {
            name: "PushUnsubscribeInput",
            fields: {
                endpoint: {
                    name: "endpoint",
                    type: "String"
                }
            }
        },
        AdminPushInput: {
            name: "AdminPushInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                title: {
                    name: "title",
                    type: "String"
                },
                body: {
                    name: "body",
                    type: "String"
                }
            }
        }
    } as const;
    enums = {
        Role: {
            name: "Role",
            values: {
                PLATFORM_ADMIN: "PLATFORM_ADMIN",
                USER: "USER"
            }
        },
        AccountRole: {
            name: "AccountRole",
            values: {
                OWNER: "OWNER",
                ADMIN: "ADMIN",
                RESPONDER: "RESPONDER",
                VIEWER: "VIEWER"
            }
        },
        UrgencyLevel: {
            name: "UrgencyLevel",
            values: {
                LOW: "LOW",
                NORMAL: "NORMAL",
                HIGH: "HIGH",
                URGENT: "URGENT"
            }
        },
        CallStatus: {
            name: "CallStatus",
            values: {
                IN_PROGRESS: "IN_PROGRESS",
                COMPLETED: "COMPLETED",
                FAILED: "FAILED"
            }
        },
        TagSource: {
            name: "TagSource",
            values: {
                AUTO: "AUTO",
                MANUAL: "MANUAL"
            }
        },
        MessageSeverity: {
            name: "MessageSeverity",
            values: {
                INFO: "INFO",
                IMPORTANT: "IMPORTANT",
                CRITICAL: "CRITICAL"
            }
        },
        MessageAudience: {
            name: "MessageAudience",
            values: {
                ACCOUNT: "ACCOUNT",
                PLATFORM_ALL: "PLATFORM_ALL",
                PLATFORM_ADMIN: "PLATFORM_ADMIN"
            }
        },
        ProvisioningStatus: {
            name: "ProvisioningStatus",
            values: {
                AVAILABLE: "AVAILABLE",
                PROVISIONING: "PROVISIONING",
                ACTIVE: "ACTIVE",
                FAILED: "FAILED",
                RELEASED: "RELEASED"
            }
        },
        OnboardingStep: {
            name: "OnboardingStep",
            values: {
                NUMBER: "NUMBER",
                AGENT_PERSONALIZATION: "AGENT_PERSONALIZATION",
                EMERGENCY_TOPICS: "EMERGENCY_TOPICS",
                FORWARDING_SETUP: "FORWARDING_SETUP",
                TEST_CALL: "TEST_CALL"
            }
        }
    } as const;
    authType = "Auth" as const;
    procedures = {
        signUp: {
            params: {
                input: { name: "input", type: "SignUpInput" }
            },
            returnType: "String",
            mutation: true
        },
        login: {
            params: {
                input: { name: "input", type: "LoginInput" }
            },
            returnType: "String",
            mutation: true
        },
        me: {
            params: {},
            returnType: "User"
        },
        changePassword: {
            params: {
                input: { name: "input", type: "ChangePasswordInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        adminSetPassword: {
            params: {
                input: { name: "input", type: "AdminSetPasswordInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        adminInviteUser: {
            params: {
                input: { name: "input", type: "AdminInviteUserInput" }
            },
            returnType: "Invite",
            mutation: true
        },
        adminCreateUser: {
            params: {
                input: { name: "input", type: "AdminCreateUserInput" }
            },
            returnType: "User",
            mutation: true
        },
        adminDeleteUser: {
            params: {
                input: { name: "input", type: "UserIdInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        acceptInvite: {
            params: {
                input: { name: "input", type: "AcceptInviteInput" }
            },
            returnType: "String",
            mutation: true
        },
        checkInvite: {
            params: {
                input: { name: "input", type: "CheckInviteInput" }
            },
            returnType: "CheckInviteResult",
            mutation: true
        },
        inviteDelegate: {
            params: {
                input: { name: "input", type: "InviteDelegateInput" }
            },
            returnType: "Invite",
            mutation: true
        },
        setMemberRole: {
            params: {
                input: { name: "input", type: "SetMemberRoleInput" }
            },
            returnType: "AccountMember",
            mutation: true
        },
        removeMember: {
            params: {
                input: { name: "input", type: "RemoveMemberInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        claimOwnAccount: {
            params: {},
            returnType: "Account",
            mutation: true
        },
        myAccounts: {
            params: {},
            returnType: "AccountSummaryList"
        },
        provisionNumber: {
            params: {
                input: { name: "input", type: "AccountIdInput" }
            },
            returnType: "PhoneNumber",
            mutation: true
        },
        assignPhoneNumber: {
            params: {
                input: { name: "input", type: "AssignPhoneNumberInput" }
            },
            returnType: "PhoneNumber",
            mutation: true
        },
        releasePhoneNumber: {
            params: {
                input: { name: "input", type: "PhoneNumberIdInput" }
            },
            returnType: "PhoneNumber",
            mutation: true
        },
        skipOnboardingStep: {
            params: {
                input: { name: "input", type: "SkipStepInput" }
            },
            returnType: "OnboardingProgress",
            mutation: true
        },
        completeOnboarding: {
            params: {
                input: { name: "input", type: "AccountIdInput" }
            },
            returnType: "OnboardingProgress",
            mutation: true
        },
        agentDeployFaq: {
            params: {
                input: { name: "input", type: "AgentDeployFaqInput" }
            },
            returnType: "AgentSyncResult",
            mutation: true
        },
        agentFetch: {
            params: {
                input: { name: "input", type: "AgentFetchInput" }
            },
            returnType: "String",
            mutation: true
        },
        agentSync: {
            params: {
                input: { name: "input", type: "AgentSyncInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        workspaceUsage: {
            params: {
                input: { name: "input", type: "WorkspaceUsageInput" }
            },
            returnType: "String"
        },
        accountUsage: {
            params: {
                input: { name: "input", type: "AccountUsageInput" }
            },
            returnType: "String"
        },
        pushPublicKey: {
            params: {},
            returnType: "String"
        },
        pushSubscribe: {
            params: {
                input: { name: "input", type: "PushSubscribeInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        pushUnsubscribe: {
            params: {
                input: { name: "input", type: "PushUnsubscribeInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        pushTest: {
            params: {},
            returnType: "Boolean",
            mutation: true
        },
        adminPushAccount: {
            params: {
                input: { name: "input", type: "AdminPushInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        inngestActivity: {
            params: {},
            returnType: "InngestActivityResult"
        },
        assistantAsk: {
            params: {
                input: { name: "input", type: "AssistantAskInput" }
            },
            returnType: "String",
            mutation: true
        }
    } as const;
    plugins = {};
}
export const schema = new SchemaType();
